module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-quantum-findx2.0932a7ba.png";